export default "__VITE_ASSET__DitnG2Mz__";